// src/lib/apiPath.ts
// Small helper to switch between private and public API scope at runtime.

let _scope: "private" | "public" = "private";

/** Call this at widget bootstrap to switch to public endpoints */
export function setApiScope(scope: "private" | "public") {
  _scope = scope;
}

/**
 * Build final url for service calls.
 * - Hooks keep metas like "/company/settings"
 * - Services call apiPath('/company/settings') which becomes:
 *     /api/v1/company/settings        (private)
 *     /api/v1/public/company/settings (public)
 *
 * If the incoming path already begins with "/public/", we do not prefix again.
 */
export function apiPath(path: string): string {
  const alreadyPublic = path.startsWith("/public/");
  const publicPrefix = _scope === "public" && !alreadyPublic ? "/public" : "";
  // Ensure path starts with a single leading slash
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `/api/v1${publicPrefix}${normalized}`;
}

/** Expose current scope for diagnostics */
export function getApiScope(): "private" | "public" {
  return _scope;
}
